'use strict';

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target, type) {
    const spinnerType = type;

    const $svgElement = $('<svg width="150" height="150" viewBox="0 0 85 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.5538 14.3609C47.4913 14.3609 51.4665 15.7297 54.4793 18.4672C57.4921 21.2047 58.9995 24.7704 58.9995 29.1641L73.9215 22.682C73.1941 18.4331 71.4699 14.5981 68.7469 11.1752C66.0239 7.7543 62.4114 5.05296 57.9094 3.07117C53.4075 1.08938 48.2896 0.0984802 42.5538 0.0984802C42.5538 0.0984802 42.5538 0.0984802 42.5518 0.0984802V14.3609C42.5518 14.3609 42.5518 14.3609 42.5538 14.3609Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M70.8176 45.2073C68.0945 41.9311 64.8447 39.5896 61.0701 38.1846C57.2935 36.7797 52.4289 35.5014 46.4763 34.3497C45.0621 34.0683 43.7573 33.7929 42.5518 33.5216V49.3457C45.8097 50.0412 48.3767 50.6602 50.2326 51.2049C52.4471 51.8521 54.299 52.845 55.7881 54.1756C57.2753 55.5102 58.0209 57.2548 58.0209 59.4155C58.0209 62.2977 56.6593 64.6212 53.9363 66.3839C51.2132 68.1506 47.7446 69.031 43.5344 69.031C43.1981 69.031 42.88 69.0089 42.5518 68.9968V83.2774C42.878 83.2834 43.2042 83.2914 43.5344 83.2914C49.4161 83.2914 54.7346 82.3367 59.4898 80.4273C64.245 78.5199 68.0033 75.71 70.7629 71.9997C73.5203 68.2913 74.9021 63.9157 74.9021 58.8728C74.9021 53.038 73.5406 48.4835 70.8176 45.2053V45.2073Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M30.5732 81.376C27.3781 78.4596 25.7815 74.4799 25.7815 69.437L10.0977 76.5682C11.4045 84.0613 15.1426 89.8418 21.316 93.9099C27.2504 97.8253 34.3316 99.8492 42.5514 100V85.7194C37.5713 85.5506 33.5698 84.1135 30.5732 81.378V81.376Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.0865 28.7038C13.3999 32.4503 12.0566 36.7355 12.0566 41.5613C12.0566 47.2514 13.4182 51.7175 16.1412 54.9595C18.8643 58.2015 22.1485 60.5069 25.9981 61.8737C29.8456 63.2424 34.7122 64.5047 40.5919 65.6543C41.2747 65.795 41.919 65.9297 42.5491 66.0644V50.2402C40.3508 49.7457 38.4969 49.2634 36.9976 48.7991C34.6737 48.0795 32.749 47.0524 31.2254 45.7199C29.6997 44.3873 28.9379 42.6045 28.9379 40.3714C28.9379 37.5616 30.2083 35.3124 32.749 33.6181C35.2897 31.9277 38.5557 31.0795 42.5491 31.0795V16.8171C36.8862 16.8171 31.7319 17.8622 27.0861 19.9506C22.4383 22.0409 18.7711 24.9573 16.0845 28.7018L16.0865 28.7038Z" fill="currentColor"/></svg>');
    const $veil = $('<div class="veil cc-veil js-veil"><div class="cc-underlay underlay"></div></div>');
    $veil.append(`<div class="spinner cc-spinner cc-icon"></div>`);
    if (spinnerType === 'loader') {
        $veil.append(`<div class="cc-spinner__loader"><div class="cc-spinner__loader__active"></div></div>`);
    }
    $veil.find('.cc-spinner').append($svgElement);
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled cc-veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

// element level spinner:
$.fn.spinner = function () {
    const $element = $(this);
    const Fn = function () {
        this.start = function () {
            if ($element.length) {
                addSpinner($element);
            }
        };
        this.stop = function () {
            if ($element.length) {
                const $veil = $('.veil');
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    const Fn = function () {
        this.start = function (type = 'default') {
            addSpinner($('body'), type);
        };
        this.stop = function () {
            removeSpinner($('.veil'));
        };
    };
    return new Fn();
};
